/* istanbul ignore file */
import { useEffect, useState } from 'react';
export function useMarketoForm({ munchkinId, munchkinIdStg, formId, formIdStg }, container) {
    const [marketo, setMarketo] = useState();
    const [status, setStatus] = useState('LOADING');
    const setFormStatus = () => setStatus('FORM');
    const setSuccessStatus = () => setStatus('SUCCESS');
    const setErrorStatus = () => setStatus('ERROR');
    useEffect(() => {
        const mktoConfig = location.hostname === 'trello.com'
            ? {
                url: '//pages.eml.atlassian.com',
                munchkinId: munchkinId,
                prefsUrl: 'https://preferences.atlassian.com/rest/forms/config',
                formId: formId
            }
            : {
                url: '//app-ab35.marketo.com',
                munchkinId: munchkinIdStg,
                prefsUrl: 'https://preferences.stg.atlassian.com/rest/forms/config',
                formId: formIdStg
            };
        const scriptId = `marketo-${mktoConfig.munchkinId}`;
        const script = document.getElementById(scriptId);
        if (!marketo) {
            if (script) {
                setMarketo(window.MktoForms2);
            }
            else {
                const script = document.createElement('script');
                script.async = true;
                script.src = `${mktoConfig.url}/js/forms2/js/forms2.min.js`;
                script.id = scriptId;
                script.onload = () => {
                    setMarketo(window.MktoForms2);
                };
                document.body.appendChild(script);
            }
        }
        else if (status === 'LOADING') {
            loadMarketoForm(marketo, mktoConfig, container, setFormStatus, setSuccessStatus, setErrorStatus);
        }
    }, [marketo, setMarketo, status, setStatus]);
    return status;
}
function loadMarketoForm(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marketo, mktoConfig, container, setFormStatus, setSuccessStatus, setErrorStatus) {
    const { $, loadForm } = marketo;
    loadForm(mktoConfig.url, mktoConfig.munchkinId, mktoConfig.formId, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (form) => {
        if (!form || !container) {
            setErrorStatus();
            return;
        }
        const $container = $(container);
        $container.hide();
        $container.append(form.render());
        const $form = $container.find('form');
        //overwrite form ID based on config
        $form.attr('id', `foo-bar-mktoForm_${mktoConfig.formId}`);
        //remove the elements we don't want
        $('#mktoForms2BaseStyle, #mktoForms2ThemeStyle, .mktoForm style, .mktoGutter, .mktoClear, .mktoOffset').remove();
        //remove style attributes from form and child elements
        $form.removeAttr('style');
        $form.find('*').removeAttr('style');
        //populate hidden date fields
        const optinDate = new Date().toISOString();
        $form.find('input[name=form_anyConsentUpdatedAt]').val(optinDate);
        $form.find('input[name=form_gmoiUpdatedAt]').val(optinDate);
        $form.find('input[name=form_privacyPolicyUpdatedAt]').val(optinDate);
        //new updated at
        const $addSubs = $form.find('input[name=form_additionalSubscriptions]');
        const $addSubsUpdated = $form.find('input[name=form_additionalSubscriptionsUpdatedAt]');
        if ($addSubs.size() &&
            $addSubs.first().val().length &&
            $addSubsUpdated.size()) {
            $addSubsUpdated.first().val(optinDate);
        }
        //populate hidden url fields
        const pageUrl = window.location.href;
        $form.find('input[name=form_gmoiFormUrl]').val(pageUrl);
        $form.find('input[name=form_privacyPolicyFormUrl]').val(pageUrl);
        //option to set the submit button text from the html
        const submitText = $form.attr('data-submit');
        if (submitText) {
            $form.find('button').text(submitText);
        }
        //callback when form is submitted
        form.onSuccess(function () {
            setSuccessStatus();
            return false;
        });
        //get preferences
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $.getJSON(mktoConfig.prefsUrl, function (data) {
            //set and hide country if it's available
            const $country = $('select#Country');
            if ($country.size() && data.locale) {
                $country.closest('.mktoFormRow').hide();
                $country.val(data.locale);
            }
            //gdpr checking
            const $gdprInput = $('input[name=form_gmoiGranted]');
            if ($gdprInput.size() &&
                !data.localeRequiresMarketingCommunicationOptIn) {
                $gdprInput.closest('.mktoFormRow').hide();
                $gdprInput.prop('checked', true);
            }
            //done checking, show form
            $container.show();
            setFormStatus();
        });
    });
}
//# sourceMappingURL=use-marketo-form.js.map